import { useEffect } from 'react';
import { canUseDOM } from './index';
var StickyCtaAssistant = function StickyCtaAssistant() {
  var checkIsMobile = function checkIsMobile() {
    var isMobile = canUseDOM && window.innerWidth <= 767;
    var footer = document.querySelector('.footer');
    if (canUseDOM) {
      if (footer && isMobile) {
        if (!footer.classList.contains('footer--extra-padding')) {
          footer.classList.add('footer--extra-padding');
        }
      }
    }
  };
  useEffect(function () {
    if (canUseDOM) {
      var footer = document.querySelector('.footer');
      var hp = document.querySelector('div[data-cy="happiness-meter"]');
      var backToTop = document.querySelector('.back-to-top');
      return function () {
        if (footer) {
          footer.classList.remove('footer--extra-padding');
        }
        if (hp) {
          hp.classList.remove('with-sticky-poi-cta');
        }
        if (backToTop) {
          backToTop.removeAttribute('data-position');
        }
      };
    }
  }, []);
  useEffect(function () {
    if (typeof document !== 'undefined' && typeof window !== 'undefined') {
      var hp = document.querySelector('div[data-cy="happiness-meter"]');
      var backToTop = document.querySelector('.back-to-top');
      if (backToTop) {
        backToTop.setAttribute('data-position', 'with-sticky-poi-cta');
      }
      if (hp) {
        hp.classList.add('with-sticky-poi-cta');
      }
    }
    if (canUseDOM) {
      window.addEventListener('resize', checkIsMobile);
      var interval = setInterval(checkIsMobile, 1000);
      return function () {
        window.removeEventListener('resize', checkIsMobile);
        clearInterval(interval);
      };
    }
  }, []);
  return null;
};
export default StickyCtaAssistant;